module.exports = "../../app/cells/pages/contests/index/card_cell.rb";